export const mutations = {
  SET_LATEST_EXPERT_RESPONSES_LOADING(state, loading) {
    state.latestExpertResponses.loading = loading
  },
  
  SET_LATEST_EXPERT_RESPONSES_DATA(state, { data, pagination }) {
    state.latestExpertResponses.data = data
    state.latestExpertResponses.pagination = pagination
  },
  
  SET_LATEST_EXPERT_RESPONSES_ERROR(state, error) {
    state.latestExpertResponses.error = error
  },
  
  CLEAR_LATEST_EXPERT_RESPONSES_ERROR(state) {
    state.latestExpertResponses.error = null
  },

  SET_LATEST_CLIENT_CONTACTS_LOADING(state, loading) {
    state.latestClientContacts.loading = loading
  },

  SET_LATEST_CLIENT_CONTACTS_DATA(state, { data, pagination }) {
    state.latestClientContacts.data = data
    state.latestClientContacts.pagination = pagination
  },

  SET_LATEST_CLIENT_CONTACTS_ERROR(state, error) {
    state.latestClientContacts.error = error
  },

  CLEAR_LATEST_CLIENT_CONTACTS_ERROR(state) {
    state.latestClientContacts.error = null
  },

  SET_STAFF_TARGETS_LOADING(state, loading) {
    state.staffTargets.loading = loading
  },

  SET_STAFF_TARGETS_DATA(state, data) {
    state.staffTargets.data = data
  },

  SET_STAFF_TARGETS_ERROR(state, error) {
    state.staffTargets.error = error
  },

  CLEAR_STAFF_TARGETS_ERROR(state) {
    state.staffTargets.error = null
  },

  SET_TEAM_TARGETS_LOADING(state, loading) {
    state.teamTargets.loading = loading
  },

  SET_TEAM_TARGETS_DATA(state, data) {
    state.teamTargets.data = data
  },

  SET_TEAM_TARGETS_ERROR(state, error) {
    state.teamTargets.error = error
  },

  CLEAR_TEAM_TARGETS_ERROR(state) {
    state.teamTargets.error = null
  }
}
